import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import JobGroupContents from '@components/match/profile/profileCard/jobGroupTitlesSelectModal/jobGroupContents';
import JobGroupTitleContents, {
  jobTitleNNamePrefix,
} from '@components/match/profile/profileCard/jobGroupTitlesSelectModal/jobGroupTitleContents';
import IJobGroupWithTitlesVO from '@domain/vo/match/IJobGroupWithTitlesVO';
import { JobGroupWithTitlesDescDto } from '@domain/rs/code/JobGroupsWithTitlesRs';

import classnames from 'classnames/bind';
import styles from './jobSelectModal.module.scss';
const cx = classnames.bind(styles);

type JobGroupAreaType = 'JOB-GROUP' | 'JOB' | null;

interface IJobSelectModalProps {
  onClose: () => void;
  jobGroupFieldName: string;
  viewData: JobGroupWithTitlesDescDto[];
  onSubmit: () => Promise<void>;
}

const JobSelectModal = ({ onClose, jobGroupFieldName, viewData, onSubmit }: IJobSelectModalProps) => {
  const { watch } = useFormContext();
  const watchJobGroups = watch(jobGroupFieldName) as JobGroupWithTitlesDescDto[];
  const isExistJobGroup = watchJobGroups?.length;

  const watchJobTitles = watch(jobTitleNNamePrefix) as IJobGroupWithTitlesVO[];
  const isExistJobTitle = watchJobTitles?.some((item: IJobGroupWithTitlesVO) => item.jobTitleCodes?.length);

  const [areaState, setAreaState] = useState<JobGroupAreaType>('JOB-GROUP');
  const isVisible = (areaType: JobGroupAreaType) => areaType === areaState;

  return (
    <>
      <div className={cx('layer')}>
        <JobGroupContents visible={isVisible('JOB-GROUP')} jobGroupList={viewData} fieldName={jobGroupFieldName} />
        <JobGroupTitleContents visible={isVisible('JOB')} jobGroupFieldName={jobGroupFieldName} />
        <div
          className={cx(
            'btnArea',
            { jobSelect: isVisible('JOB') },
            { type1: isExistJobGroup && !isExistJobTitle },
            { type2: isExistJobTitle },
          )}
        >
          {isVisible('JOB-GROUP') && (
            <button
              className={cx('btnNext')}
              type="button"
              onClick={() => setAreaState('JOB')}
              disabled={!isExistJobGroup}
            >
              다음
            </button>
          )}
          {isVisible('JOB') && (
            <>
              <a className={cx('btnPrev')} role="button" onClick={() => setAreaState('JOB-GROUP')}>
                이전
              </a>
              <button className={cx('btnConfirm')} type="button" onClick={onSubmit} disabled={!isExistJobTitle}>
                선택 완료
              </button>
            </>
          )}
        </div>
      </div>
      <a className={cx('btnClose')} onClick={onClose} role="button">
        <span className={cx('hidden')}>close</span>
      </a>
    </>
  );
};

export default JobSelectModal;
